var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
var HistoryCurveCalibrationMarkComponent = /** @class */ (function (_super) {
    __extends(HistoryCurveCalibrationMarkComponent, _super);
    function HistoryCurveCalibrationMarkComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.emptyFont = {
            fontSize: '12px',
            isBold: false,
            isItalic: false,
            isUnderline: false,
            color: '#000000',
            fontFamily: 'sans-serif'
        };
        return _this;
    }
    Object.defineProperty(HistoryCurveCalibrationMarkComponent.prototype, "showCalibrationDigit", {
        get: function () {
            return this.data.showCalibrationDigit;
        },
        set: function (value) {
            this.data.showCalibrationDigit = value;
            this._showCalibrationDigit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveCalibrationMarkComponent.prototype, "showCalibration", {
        get: function () {
            return this.data.showCalibration;
        },
        set: function (value) {
            this.data.showCalibration = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveCalibrationMarkComponent.prototype, "calibrationDigitFont", {
        get: function () {
            return this.data.calibrationDigitFont;
        },
        set: function (val) {
            this.data.calibrationDigitFont = val;
            this._calibrationDigitFontBak = val;
        },
        enumerable: true,
        configurable: true
    });
    HistoryCurveCalibrationMarkComponent.prototype.ngOnInit = function () {
        if (this.showCalibrationDigit) {
            if (!this.data.calibrationDigitFont) {
                this.calibrationDigitFont = _.cloneDeep(this.emptyFont);
            }
            this._calibrationDigitFontBak = this.data.calibrationDigitFont;
            this._showCalibrationDigit = this.data.showCalibrationDigit;
        }
    };
    HistoryCurveCalibrationMarkComponent.prototype.showCalibrationDigitChanged = function () {
        if (this.showCalibrationDigit) {
            if (!this.calibrationDigitFont) {
                this.calibrationDigitFont = _.cloneDeep(this._calibrationDigitFontBak || this.emptyFont);
            }
        }
        else {
            delete this.data.calibrationDigitFont;
        }
    };
    HistoryCurveCalibrationMarkComponent.prototype.showCalibrationChanged = function () {
        if (!this.showCalibration) {
            delete this.data.calibrationColor;
            delete this.data.showCalibrationDigit;
            delete this.data.calibrationDigitFont;
        }
        else {
            this.data.showCalibrationDigit = this._showCalibrationDigit;
            this.data.calibrationDigitFont = this._calibrationDigitFontBak;
        }
    };
    HistoryCurveCalibrationMarkComponent.prototype.validate = function () {
        return true;
    };
    __decorate([
        Input()
    ], HistoryCurveCalibrationMarkComponent.prototype, "data", void 0);
    HistoryCurveCalibrationMarkComponent = __decorate([
        Component({
            selector: 'history-curve-calibration-mark',
            styles: [".add-margin { margin-left: 10px; } .form-inline-label { line-height: 12px; } .sep { width: 100%; height: 0; margin-top: 10px; } .inline-control { display: inline-block; select { width: 144px !important; } } .lb-color { margin-right: 10px; } .inline-control { margin-left: 7px; } "],
            template: "<form novalidate #form=\"ngForm\" name=\"calibrationForm\"> <div class=\"fe-modal-body\"> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" [(ngModel)]=\"showCalibration\" name=\"ShowCalibration\" (ngModelChange)=\"showCalibrationChanged()\"/>       <span>{{lc('ShowCalibration')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"showCalibration\"> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" [(ngModel)]=\"showCalibrationDigit\" name=\"ShowCalibrationDigit\" (ngModelChange)=\"showCalibrationDigitChanged()\"/> <span>{{lc('ShowCalibrationDigit')}}</span> </label> </div> <div class=\"fe-transverse-label clearfix\" *ngIf=\"showCalibrationDigit\"> <label class=\"fe-transverse-title\">{{lc('FontProperty')}}:</label> <div class=\"fe-transverse-component\"> <font-setting [FontFamilyEnabled]=\"false\" [font]=\"calibrationDigitFont\" [textAlignEnabled]=\"false\" [underLineEnabled]=\"false\" [fontColorEnabled]=\"false\" [boldEnabled]=\"false\" [italicEnabled]=\"false\"></font-setting> </div> </div> </div> </div> </form> ",
            encapsulation: ViewEncapsulation.None
        })
    ], HistoryCurveCalibrationMarkComponent);
    return HistoryCurveCalibrationMarkComponent;
}(ConfigureComponentBase));
export { HistoryCurveCalibrationMarkComponent };
